import { SportEvent, SportPromoSelection } from '@funtech-int/kp-graphql-sdk/yango-movies-www';
import { AnalyticsSender } from '@funtech-int/yango-shared';

import {
    SportNamespaces,
    SportUuidType,
    SportEntityType,
} from '@kinopoisk-int/evgen-web-sport-events/kp/named_enums';
import { sportShowed } from '@kinopoisk-int/evgen-web-sport-events/kp/sport';
import {
    windowItemNavigatedV4,
    WindowItemNavigatedV4From,
    WindowItemNavigatedV4To,
    windowItemShowedV3,
} from '@kinopoisk-int/evgen-web-sport-events/kp/window_item';
import { sportEventShowed } from '@kinopoisk-int/evgen-web-sport-events/kp/sport_event';

interface CardParams {
    uuid: string;
    title: string;
    cardPosition: number;
}

interface SportPromoCardNavigatedParams extends CardParams {
    to: 'payment' | 'player';
}

export interface SportPromoAnalytics {
    cardShowed: (cardParams: CardParams) => void;
    cardNavigated: (cardParams: SportPromoCardNavigatedParams) => void;
}

export const createSportShowcaseAnalytics = (eventSender: AnalyticsSender) => {
    let showcaseId = '';

    const setShowcaseId = (id: string) => {
        showcaseId = id;
    };

    const pageShowed = () => {
        eventSender.sendOnce(sportShowed, {}, { namespace: SportNamespaces.Sport });
    };

    const createSportPromoAnalytics = (
        selection: SportPromoSelection,
        position: number
    ): SportPromoAnalytics => ({
        cardShowed(cardParams) {
            eventSender.sendOnce(
                windowItemShowedV3,
                {
                    showcaseId,
                    page: SportNamespaces.Sport,
                    windowId: SportNamespaces.Sport,
                    uuidType: SportUuidType.Sport,
                    entityType: SportEntityType.PROMOSELECTION,
                    selectionId: selection.id,
                    selectionPosition: position,
                    ...cardParams,
                },
                {
                    namespace: SportNamespaces.Sport,
                }
            );
        },
        cardNavigated({ to, ...cardParams }) {
            const navigatedTo = (() => {
                switch (to) {
                    case 'player':
                        return WindowItemNavigatedV4To.PlayerScreen;
                    case 'payment':
                        return WindowItemNavigatedV4To.Payment;
                    default:
                        throw new Error(`Unknown to: ${to}`);
                }
            })();

            eventSender.send(
                windowItemNavigatedV4,
                {
                    showcaseId,
                    page: SportNamespaces.Sport,
                    windowId: SportNamespaces.Sport,
                    uuidType: SportUuidType.Sport,
                    from: WindowItemNavigatedV4From.SportScreen,
                    to: navigatedTo,
                    entityType: SportEntityType.PROMOSELECTION,
                    selectionId: selection.id,
                    selectionPosition: position,
                    ...cardParams,
                },
                {
                    namespace: SportNamespaces.Sport,
                }
            );
        },
    });

    return {
        setShowcaseId,
        pageShowed,
        createSportPromoAnalytics,
    };
};

export const createSportEventScreenAnalytics = (
    eventSender: AnalyticsSender,
    sportEvent: SportEvent
) => {
    const pageShowed = () => {
        eventSender.sendOnce(
            sportEventShowed,
            {
                entityType: SportEntityType.SPORTEVENTS,
                uuid: sportEvent.id,
                title: sportEvent.title,
            },
            { namespace: SportNamespaces.SportEvent }
        );
    };

    return {
        pageShowed,
    };
};
